import axios from "axios";
import { cusAxios, PREFIX } from "./main";

const info = async (data) => {
  let response = await axios({
    method: "POST",
    url: `${PREFIX}/api/gamers/casino_info`,
    data: data
  });
  return response;
};

const getGameUrl = async (data) => {
  let response = await axios({
    method: "POST",
    url: `${PREFIX}/api/gamers/start_game`,
    data: { ...data }
  });
  return response;
};

const getBonusGameUrl = async (data) => {
  let response = await axios({
    method: "POST",
    url: `${PREFIX}/api/gamers/start_bonus`,
    data: { ...data }
  });
  return response;
};

const getGameStat = async () => {
  let response = await axios({
    method: "POST",
    url: `${PREFIX}/api/gamers/game_stat`
  });
  return response;
};

const getBonuses = async ({ start_r, currency }) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/get_bonuses`,
    data: { start_r, currency }
  });
  return response;
};

const setActive = async (data) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/bonus_set_activation`,
    data: { ...data }
  });
  return response;
};

const getJackpots = async ({ start_r, currency }) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/get_jackpots`,
    data: { start_r, currency }
  });
  return response;
};

const getCampaignId = async ({ start_r, campaignId }) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/campaign_info`,
    data: { start_r, campaignId }
  });
  return response;
};

const checkDomain = async ({ start_r, domain }) => {
  let response = await axios({
    method: "POST",
    url: `${PREFIX}/api/gamers/check_domain`,
    data: { start_r, domain }
  });
  return response;
};

const captchaUsing = async ({ start_r }) => {
  let response = await axios({
    method: "POST",
    url: `${PREFIX}/api/gamers/captcha_using`,
    data: { start_r }
  });
  return response;
};

const getAgreement = async ({ lang }) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/agreement`,
    data: { lang }
  });
  return response;
};

const getProviderList = async (collectionId, currency) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/provider_list`,
    data: { collectionId, currency }
  });
  return response;
};

const getProviderGamesList = async ({ providerId, collectionId, maxGames }) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/provider_game_list`,
    data: { providerId, collectionId, maxGames }
  });
  return response;
};

const getCategoryGamesList = async ({ categoryId, maxGames, currency }) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/category_game_list`,
    data: { categoryId, maxGames, currency }
  });
  return response;
};

const getGamesByString = async ({ sample, currency }) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/search_game`,
    data: { sample, currency }
  });
  return response;
};

const getGamesById = async ({ gameId, currency }) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/game_info`,
    data: { gameId, currency }
  });
  return response;
};

const getHitGames = async ({ maxGames, currency } = {}) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/hit_game_list`,
    data: { maxGames, currency }
  });
  return response;
};

const getFavoritesGames = async ({ maxGames, currency }) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/favorites_game_list`,
    data: { maxGames, currency }
  });
  return response;
};

const getCollectionGames = async ({ collectionId, maxGames, currency }) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/collection_game_list`,
    data: { collectionId, maxGames, currency }
  });
  return response;
};

export const API_CASINO = {
  info,
  getGameUrl,
  getBonusGameUrl,
  getGameStat,
  getJackpots,
  getCampaignId,
  captchaUsing,
  checkEmailDomain: checkDomain,
  agreement: getAgreement,
  list: {
    providers: getProviderList,
    providerGames: getProviderGamesList,
    categoryGames: getCategoryGamesList,
    search: getGamesByString,
    games: getGamesById,
    hit: getHitGames,
    favorites: getFavoritesGames,
    collection: getCollectionGames
  },
  bonus: {
    get: getBonuses,
    setActive
  }
};
